const savedBlocks = [
  {
    id: 111,
    name: "AAA složka",
    created_at: "2024-11-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 112,
    name: "test",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-11-16T14:48:00.000Z",
    type: "saved_block",
    folder_id: 1,
  },
  {
    id: 113,
    name: "test 2",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-01-15T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 114,
    name: "Můj blok",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-10T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 115,
    name: "ma folder",
    created_at: "2023-11-18T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 116,
    name: "test a tak",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-11-25T14:48:00.000Z",
    type: "saved_block",
    folder_id: 1,
  },
  {
    id: 117,
    name: "Jak jako",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-02-15T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 118,
    name: "Můj blok 2",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-11T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 119,
    name: "složka",
    created_at: "2023-01-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 210,
    name: "Moje",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-12-15T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 211,
    name: "Tvoje",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-01-10T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 212,
    name: "Naše",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-08T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 213,
    name: "Schované",
    created_at: "2023-09-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 214,
    name: "Kraj",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-08-15T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 215,
    name: "Obec",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-01-25T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 216,
    name: "MMěsto",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-06T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 217,
    name: "Další schovka",
    created_at: "2023-06-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 218,
    name: "Bože",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-12-25T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 219,
    name: "Nechci",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-02-16T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 220,
    name: "Můj blok 3",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-18T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 221,
    name: "tajné",
    created_at: "2023-12-24T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 222,
    name: "nechci",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-11-05T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 223,
    name: "Další",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-11-15T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 224,
    name: "AA první",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-01T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 225,
    name: "složička",
    created_at: "2023-01-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 226,
    name: "test 10",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-11-15T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 227,
    name: "test 2",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-01-15T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 228,
    name: "Můj blok",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-10T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 229,
    name: "ma folder",
    created_at: "2023-11-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 230,
    name: "test",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-11-15T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 231,
    name: "test 2",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-01-15T14:48:00.000Z",
    type: "saved_block",
  },
  {
    id: 232,
    name: "Můj blok",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-10T14:48:00.000Z",
    type: "saved_block",
  },
];

let i = 32;

export const getSavedBlocks = ({ request }) => {
  const url = new URL(request.url);
  const sortBy = url.searchParams.get("sort_by");
  const desc = url.searchParams.get("desc");
  // Absent per_page means 15 here, like app.topol.io today, so the e2e suite
  // exercises the editor's fallback walk (see collectAllPages).
  const perPage = Number(url.searchParams.get("per_page")) || 15;
  const page = Number(url.searchParams.get("current_page")) || 1;
  const search = url.searchParams.get("search");
  const folderId = url.searchParams.get("folder_id");
  const type = url.searchParams.get("type");

  let returnSavedBlocks = savedBlocks;
  if (folderId && folderId !== "") {
    returnSavedBlocks = returnSavedBlocks.filter(
      (item) => item.folder_id === Number(folderId)
    );
  } else {
    returnSavedBlocks = returnSavedBlocks.filter(
      (item) => item.folder_id === undefined
    );
  }

  // "folder" lists only folders; a block type lists that type plus folders.
  if (type && type !== "") {
    returnSavedBlocks = returnSavedBlocks.filter(
      (item) => item.type === type || item.type === "folder"
    );
  }

  if (search) {
    returnSavedBlocks = returnSavedBlocks.filter((item) =>
      item.name.toLocaleLowerCase().includes(search.toLocaleLowerCase())
    );
  }

  const compareByDate = (a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    if (dateA > dateB) {
      if (desc === "true") return 1;
      return -1;
    } else if (dateA < dateB) {
      if (desc === "true") return -1;
      return 1;
    }
    return 0;
  };
  returnSavedBlocks.sort(compareByDate);

  if (sortBy === "name") {
    const compareByName = (a, b) => {
      if (a.name < b.name) {
        if (desc === "true") return 1;
        return -1;
      }
      if (a.name > b.name) {
        if (desc === "true") return -1;
        return 1;
      }
      return 0;
    };
    returnSavedBlocks.sort(compareByName);
  }

  if (sortBy === "type") {
    const compareByType = (a, b) => {
      if (a.type < b.type) {
        if (desc === "true") return 1;
        return -1;
      }
      if (a.type > b.type) {
        if (desc === "true") return -1;
        return 1;
      }
      return 0;
    };
    returnSavedBlocks.sort(compareByType);
  }

  const result = returnSavedBlocks.slice(perPage * (page - 1), perPage * page);

  return new Response(
    JSON.stringify({
      success: true,
      data: {
        data: result,
        lastPage: Math.max(1, Math.ceil(returnSavedBlocks.length / perPage)),
      },
    }),
    {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const addSavedBlock = async ({ request }) => {
  const body = await request.json();
  const { definition, img, name, type, folder_id } = body;

  if (type === "folder" && name !== "") {
    i++;
    savedBlocks.push({
      id: i,
      name: name,
      created_at: new Date(Date.now()).toISOString(),
      type: type,
    });
    if (folder_id) {
      savedBlocks.find((item) => item.id === i).folder_id = folder_id;
    }
  }

  if (type === "saved_block" && definition && name !== "") {
    i++;
    savedBlocks.push({
      id: i,
      name: name,
      definition: definition,
      image: img,
      created_at: new Date(Date.now()).toISOString(),
      type: type,
    });
    if (folder_id) {
      savedBlocks.find((item) => item.id === i).folder_id = folder_id;
    }
  }

  return new Response("", {
    status: 200,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const replaceBlock = async ({ request, params }) => {
  const { savedId } = params;
  const body = await request.json();
  const { folder_id, name } = body;

  let success = false;

  const thisSavedBlock = savedBlocks.find(
    (item) => item.id === Number(savedId)
  );

  if (!thisSavedBlock) {
    return new Response("", {
      status: 400,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  if (folder_id) {
    thisSavedBlock.folder_id = folder_id;
    success = true;
  }

  if (name) {
    const sameName = savedBlocks.find((item) => item.name === name);
    if (sameName) {
      success = false;
    } else {
      thisSavedBlock.name = name;
      success = true;
    }
  }

  return new Response("", {
    status: success ? 200 : 400,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const deleteSavedBlock = async ({ request }) => {
  const body = await request.json();
  const { blocksToDelete } = body;
  let error = false;

  blocksToDelete.map((deleteId) => {
    const indexToDelete = savedBlocks.findIndex((item) => item.id === deleteId);
    if (indexToDelete !== -1) {
      savedBlocks.splice(indexToDelete, 1);
    } else {
      error = true;
    }
  });

  return new Response("", {
    status: !error ? 200 : 400,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
